import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback, useState } from '@redneckz/uni-jsx/lib/hooks';
import { useRegions } from '../../hooks/useRegions.js';
import { BlockWrapper } from '../../ui-kit/BlockWrapper.js';
import { Heading } from '../../ui-kit/Heading/Heading.js';
import { Paragraph } from '../../ui-kit/Paragraph/Paragraph.js';
import { YandexMap } from '../../ui-kit/YandexMap/YandexMap.js';
import { SafeDepositRentalForm } from './SafeDepositRentalForm.js';
import { useSafeBoxes } from './useSafeBoxes.js';
import { getBranch, getCoordinates } from './utils.js';
const DEFAULT_DAYS = 26;
export const SafeDepositRental = JSX(({ title, footnote, className = '', ...rest }) => {
    const [showMap, setShowMap] = useState(false);
    const handleShowMap = useCallback(() => setShowMap((_) => !_), []);
    const [safeDepositState, setStateDepositState] = useState({
        selectedRegion: '',
        selectedBranch: '',
        selectedCaseVolume: '',
        selectedBoxSize: '',
        days: DEFAULT_DAYS,
    });
    const regions = useRegions();
    const selectedRegion = normalizeSelectedRegion(safeDepositState.selectedRegion, regions);
    const branches = useSafeBoxes(selectedRegion);
    const handleChangeSafeDepositState = useCallback((state) => setStateDepositState((oldState) => ({ ...oldState, ...state })), [setStateDepositState]);
    const points = getCoordinates(getBranch(branches, safeDepositState.selectedBranch) || branches);
    return (_jsxs(BlockWrapper, { className: className, defaultPadding: "", ...rest, children: [_jsxs("div", { className: "p-4xl space-y-xl", children: [title ? (_jsx(Heading, { title: title, headingType: "h3", as: "h2", className: "text-primary-text mb-s text-center" })) : null, _jsx(SafeDepositRentalForm, { regions: regions, branches: branches, data: { ...safeDepositState, selectedRegion }, onClick: handleShowMap, onChange: handleChangeSafeDepositState }), footnote ? (_jsx(Paragraph, { size: "text-s", font: "font-light", children: footnote })) : null] }), points.length && showMap ? _jsx(YandexMap, { points: points, className: "h-[640px]" }) : null] }));
});
const normalizeSelectedRegion = (selectedRegion, regions) => !selectedRegion && regions?.length && regions[0]?.code ? regions[0].code : selectedRegion;
//# sourceMappingURL=SafeDepositRental.js.map